// ==================== UNAUTHORIZED PAGE ====================

import React from 'react';
import { Box, Typography } from '@mui/material';
import { Shield, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../../contexts/ThemeContext';
import GradientBox from '../../components/ui/GradientBox';
import CustomButton from '../../components/ui/CustomButton';

const UnauthorizedPage = () => {
  const navigate = useNavigate();
  const { colors } = useTheme();

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      sx={{
        background: colors.background.gradient,
        padding: 3,
      }}
    >
      <GradientBox
        glass
        sx={{
          padding: 4,
          textAlign: 'center',
          maxWidth: 500,
          borderRadius: 3,
        }}
      >
        <Shield
          size={80}
          color={colors.error.main}
          style={{ marginBottom: 24 }}
        />

        <Typography variant="h3" gutterBottom sx={{ fontWeight: 600 }}>
          Access Denied
        </Typography>

        <Typography variant="h6" color="textSecondary" sx={{ mb: 3 }}>
          You don't have permission to access this page
        </Typography>

        <Typography variant="body1" color="textSecondary" sx={{ mb: 4 }}>
          Please contact your administrator if you believe this is an error.
        </Typography>

        <CustomButton
          variant="gradient"
          gradient="primary"
          startIcon={<ArrowLeft size={20} />}
          onClick={() => navigate('/dashboard')}
          size="large"
        >
          Go to Dashboard
        </CustomButton>
      </GradientBox>
    </Box>
  );
};

export default UnauthorizedPage;
